export const projects = [
  {
    slug: 'madeeda-hospitals',
    imgSrc: '/images/projects/madeeda-hospitals/cover.jpg',
    liveUrl: 'https://edumadeeda2.odoo.com/',
    industry: 'healthcare',
    services: ['odoo', 'web'],
    year: '2026',
    title: { en: 'Madeeda Hospitals', ar: 'مستشفيات مديدة' },
    tags: {
      en: ['Odoo', 'Website', 'Healthcare'],
      ar: ['أودو', 'موقع إلكتروني', 'رعاية صحية'],
    },
    summary: {
      en: 'A bilingual Odoo website for a Saudi rehabilitation and extended-care hospital group.',
      ar: 'موقع إلكتروني ثنائي اللغة مبني على أودو لمجموعة مستشفيات سعودية متخصصة في التأهيل والرعاية الممتدة.',
    },
    client: { en: 'Madeeda Hospitals', ar: 'مستشفيات مديدة' },
    role: {
      en: 'Odoo website development',
      ar: 'تطوير موقع إلكتروني على أودو',
    },
    overview: {
      en: 'Madeeda Hospitals is a newly established long-term care and rehabilitation hospital group in Saudi Arabia, with a 340-bed capacity. We built its complete website on Odoo in English and Arabic: 14 service pages — from neuro rehabilitation and post-stroke care to dialysis and pharmacy — plus patient-experience pages, a blog, and a careers section.',
      ar: 'مستشفيات مديدة وجهة صحية حديثة التأسيس متخصصة في الرعاية طويلة الأمد والتأهيل في المملكة العربية السعودية، بسعة 340 سريراً. بنينا موقعها الإلكتروني بالكامل على أودو باللغتين العربية والإنجليزية: 14 صفحة خدمات — من التأهيل العصبي ورعاية ما بعد الجلطة إلى الغسيل الكلوي والصيدلية — إلى جانب صفحات تجربة المريض والمدونة وقسم التوظيف.',
    },
    challenge: {
      en: 'A hospital website has to serve patients, families, and job seekers at the same time — in two languages, with full right-to-left Arabic — while building trust from the first screen and making it easy to book, call, or give feedback.',
      ar: 'على موقع المستشفى أن يخدم المرضى وذويهم والباحثين عن عمل في الوقت نفسه، وبلغتين مع دعم كامل للعربية من اليمين إلى اليسار، وأن يبني الثقة من الشاشة الأولى ويُسهّل الحجز والاتصال وتقديم الملاحظات.',
    },
    solution: {
      en: 'We built the site on Odoo Website so the hospital team can edit every page in Odoo’s builder. Appointment booking, complaints, a patient satisfaction survey, and job applications with CV upload are all native Odoo forms. Accreditation badges sit right under the hero, and click-to-call and WhatsApp buttons stay on screen on every device.',
      ar: 'بنينا الموقع على Odoo Website ليتمكن فريق المستشفى من تعديل كل صفحة من محرر أودو مباشرة. حجز المواعيد والشكاوى واستبيان رضا المرضى وطلبات التوظيف مع رفع السيرة الذاتية كلها نماذج أودو أصلية. وتظهر شارات الاعتماد أسفل الواجهة الرئيسية مباشرة، مع أزرار اتصال وواتساب ثابتة على جميع الأجهزة.',
    },
    results: {
      en: [
        '14 service pages in English and Arabic',
        'Online forms for appointments, complaints, surveys, and job applications',
        'Content the hospital team edits itself in Odoo',
      ],
      ar: [
        '14 صفحة خدمات باللغتين العربية والإنجليزية',
        'نماذج إلكترونية للمواعيد والشكاوى والاستبيانات وطلبات التوظيف',
        'محتوى يديره فريق المستشفى بنفسه من أودو',
      ],
    },
    stack: ['Odoo Website', 'Odoo Forms', 'QWeb', 'Bootstrap', 'Arabic RTL', 'WhatsApp'],
    gallery: {
      desktop: [
        { src: '/images/projects/madeeda-hospitals/desktop-home.webp', alt: { en: 'Home page on desktop', ar: 'الصفحة الرئيسية على سطح المكتب' } },
        { src: '/images/projects/madeeda-hospitals/desktop-services.webp', alt: { en: 'Services on desktop', ar: 'الخدمات على سطح المكتب' } },
        { src: '/images/projects/madeeda-hospitals/desktop-ar.webp', alt: { en: 'Arabic home page on desktop', ar: 'الصفحة الرئيسية بالعربية على سطح المكتب' } },
        { src: '/images/projects/madeeda-hospitals/desktop-recruitment.webp', alt: { en: 'Careers page on desktop', ar: 'صفحة التوظيف على سطح المكتب' } },
      ],
      tablet: [
        { src: '/images/projects/madeeda-hospitals/tablet-home.webp', alt: { en: 'Home page on tablet', ar: 'الصفحة الرئيسية على الجهاز اللوحي' } },
      ],
      mobile: [
        { src: '/images/projects/madeeda-hospitals/mobile-home.webp', alt: { en: 'Home page on mobile', ar: 'الصفحة الرئيسية على الجوال' } },
        { src: '/images/projects/madeeda-hospitals/mobile-ar.webp', alt: { en: 'Arabic home page on mobile', ar: 'الصفحة الرئيسية بالعربية على الجوال' } },
        { src: '/images/projects/madeeda-hospitals/mobile-services.webp', alt: { en: 'Services on mobile', ar: 'الخدمات على الجوال' } },
      ],
    },
  },
  {
    slug: 'agent-seven',
    imgSrc: '/images/projects/agent-seven/cover.jpg',
    liveUrl: 'https://www.agentsevensa.com/',
    industry: 'services',
    services: ['web'],
    title: { en: 'Agent Seven Media', ar: 'مؤسسة إيجنت سفن' },
    tags: {
      en: ['WordPress', 'Website', 'Media production'],
      ar: ['ووردبريس', 'موقع إلكتروني', 'إنتاج إعلامي'],
    },
    summary: {
      en: 'A bilingual WordPress website for a Saudi media production and photography studio.',
      ar: 'موقع إلكتروني ثنائي اللغة على ووردبريس لمؤسسة سعودية للإنتاج الإعلامي والتصوير.',
    },
    client: { en: 'Agent Seven Media', ar: 'مؤسسة إيجنت سفن' },
    role: {
      en: 'WordPress website design & development',
      ar: 'تصميم وتطوير موقع ووردبريس',
    },
    overview: {
      en: 'Agent Seven is a Saudi media production company covering everything from concept and scripting to filming, post-production, and distribution. We built its website in Arabic and English, showcasing 12 photography services — events, weddings, official visits, real estate, restaurants, cafés, perfumes, drone shoots, and more — each with its own gallery page.',
      ar: 'إيجنت سفن مؤسسة سعودية للإنتاج الإعلامي تغطي كل المراحل من الفكرة وكتابة السيناريو إلى التصوير والمونتاج والتوزيع. بنينا موقعها باللغتين العربية والإنجليزية ليعرض 12 خدمة تصوير — الفعاليات والأعراس والزيارات الرسمية والعقارات والمطاعم والكافيهات والعطور وتصوير الدرون وغيرها — لكل منها صفحة معرض خاصة.',
    },
    challenge: {
      en: 'For a production studio, the work is the pitch. Visitors needed to see real shoots for the exact service they want, in their language, and reach the team immediately — most of them from a phone.',
      ar: 'في استوديو الإنتاج، الأعمال هي أفضل عرض. احتاج الزائر إلى مشاهدة تصوير حقيقي للخدمة التي يريدها بالضبط وبلغته، والتواصل مع الفريق فوراً — ومعظم الزوار من الجوال.',
    },
    solution: {
      en: 'A dark, cinematic site that leads with a full-screen hero, a visual services grid, and a dedicated photo gallery for every service. A floating WhatsApp button and click-to-call keep booking one tap away, with client testimonials and social links to TikTok, Instagram, and Snapchat.',
      ar: 'موقع بطابع سينمائي داكن يبدأ بواجهة بملء الشاشة، وشبكة خدمات مرئية، ومعرض صور مخصص لكل خدمة. ويبقى الحجز على بُعد نقرة واحدة عبر زر واتساب عائم والاتصال المباشر، مع آراء العملاء وروابط تيك توك وإنستغرام وسناب شات.',
    },
    results: {
      en: [
        '12 photography services, each with its own gallery',
        'Full Arabic and English versions',
        'One-tap WhatsApp and phone booking',
      ],
      ar: [
        '12 خدمة تصوير لكل منها معرض خاص',
        'نسختان كاملتان بالعربية والإنجليزية',
        'حجز بنقرة واحدة عبر واتساب والهاتف',
      ],
    },
    stack: ['WordPress', 'Bootstrap', 'Owl Carousel', 'Arabic RTL', 'WhatsApp'],
    gallery: {
      desktop: [
        { src: '/images/projects/agent-seven/desktop-home.webp', alt: { en: 'Home page on desktop', ar: 'الصفحة الرئيسية على سطح المكتب' } },
        { src: '/images/projects/agent-seven/desktop-services.webp', alt: { en: 'Services grid on desktop', ar: 'شبكة الخدمات على سطح المكتب' } },
        { src: '/images/projects/agent-seven/desktop-service.webp', alt: { en: 'Drone photography gallery on desktop', ar: 'معرض تصوير الدرون على سطح المكتب' } },
      ],
      tablet: [
        { src: '/images/projects/agent-seven/tablet-home.webp', alt: { en: 'Home page on tablet', ar: 'الصفحة الرئيسية على الجهاز اللوحي' } },
      ],
      mobile: [
        { src: '/images/projects/agent-seven/mobile-home.webp', alt: { en: 'Arabic home page on mobile', ar: 'الصفحة الرئيسية بالعربية على الجوال' } },
        { src: '/images/projects/agent-seven/mobile-services.webp', alt: { en: 'Services on mobile', ar: 'الخدمات على الجوال' } },
        { src: '/images/projects/agent-seven/mobile-en.webp', alt: { en: 'English home page on mobile', ar: 'الصفحة الرئيسية بالإنجليزية على الجوال' } },
      ],
    },
  },
  {
    slug: 'above-group',
    imgSrc: '/images/projects/above-group/cover.jpg',
    liveUrl: 'https://abovegroupsa.com/',
    industry: 'real-estate',
    services: ['web'],
    year: '2025',
    title: { en: 'Above Group', ar: 'مجموعة أبوف' },
    tags: {
      en: ['WordPress', 'Elementor', 'Architecture'],
      ar: ['ووردبريس', 'إليمنتور', 'عمارة'],
    },
    summary: {
      en: 'A bilingual WordPress website for a Riyadh architecture, interior design, and fit-out company.',
      ar: 'موقع إلكتروني ثنائي اللغة على ووردبريس لشركة في الرياض متخصصة في التصميم المعماري والداخلي والتنفيذ.',
    },
    client: { en: 'Above Group', ar: 'مجموعة أبوف' },
    role: {
      en: 'WordPress website design & development',
      ar: 'تصميم وتطوير موقع ووردبريس',
    },
    overview: {
      en: 'Above Group is a Riyadh-based design and build company founded by Saudi engineers, delivering architectural design, interior fit-out, supply, and installation across Saudi Arabia and the GCC. We built its website in English and Arabic: a bold brand-led home page, services, founders, a project showcase split into architecture and interior work, and a contact form.',
      ar: 'مجموعة أبوف شركة سعودية مقرها الرياض متخصصة في التصميم والتنفيذ، أسسها فريق من المهندسين السعوديين، وتقدّم التصميم المعماري والتشطيب الداخلي والتوريد والتركيب في المملكة ودول الخليج. بنينا موقعها باللغتين الإنجليزية والعربية: صفحة رئيسية بهوية قوية، والخدمات، والمؤسسون، ومعرض مشاريع مقسّم إلى أعمال معمارية وداخلية، ونموذج تواصل.',
    },
    challenge: {
      en: 'Luxury architecture is sold on visuals. The site had to feel as premium as the buildings — large imagery, confident typography — while staying fast, fully bilingual, and easy for the team to update with new projects.',
      ar: 'العمارة الفاخرة تُسوَّق بالصورة. كان على الموقع أن يبدو بفخامة المباني نفسها — صور كبيرة وخطوط واثقة — مع بقائه سريعاً وثنائي اللغة بالكامل وسهل التحديث بالمشاريع الجديدة.',
    },
    solution: {
      en: 'We built it on WordPress with Elementor so the team edits pages and adds projects without a developer, and Polylang for full English and Arabic versions. A cinematic full-screen hero, animated counters for 30+ clients and 40+ projects, scroll-driven service sections, and image-led project galleries carry the brand, with a WhatsApp chat button and a "Join Us" recruitment tab always within reach.',
      ar: 'بنينا الموقع على ووردبريس مع إليمنتور ليتمكن الفريق من تعديل الصفحات وإضافة المشاريع دون مطوّر، مع Polylang لنسختين كاملتين بالإنجليزية والعربية. واجهة سينمائية بملء الشاشة، وعدّادات متحركة لأكثر من 30 عميلاً و40 مشروعاً، وأقسام خدمات تتفاعل مع التمرير، ومعارض مشاريع تقودها الصور — مع زر محادثة واتساب وتبويب "انضم إلينا" للتوظيف في متناول اليد دائماً.',
    },
    results: {
      en: [
        'Full English and Arabic versions',
        'Project showcase for architecture and interior work',
        'Pages and projects the team updates itself',
      ],
      ar: [
        'نسختان كاملتان بالإنجليزية والعربية',
        'معرض مشاريع للأعمال المعمارية والداخلية',
        'صفحات ومشاريع يحدّثها الفريق بنفسه',
      ],
    },
    stack: ['WordPress', 'Elementor', 'Polylang', 'Arabic RTL', 'WhatsApp'],
    gallery: {
      desktop: [
        { src: '/images/projects/above-group/desktop-home.webp', alt: { en: 'Home page on desktop', ar: 'الصفحة الرئيسية على سطح المكتب' } },
        { src: '/images/projects/above-group/desktop-ar.webp', alt: { en: 'Arabic home page on desktop', ar: 'الصفحة الرئيسية بالعربية على سطح المكتب' } },
        { src: '/images/projects/above-group/desktop-projects.webp', alt: { en: 'Projects on desktop', ar: 'المشاريع على سطح المكتب' } },
      ],
      tablet: [
        { src: '/images/projects/above-group/tablet-home.webp', alt: { en: 'Home page on tablet', ar: 'الصفحة الرئيسية على الجهاز اللوحي' } },
      ],
      mobile: [
        { src: '/images/projects/above-group/mobile-home.webp', alt: { en: 'Home page on mobile', ar: 'الصفحة الرئيسية على الجوال' } },
        { src: '/images/projects/above-group/mobile-ar.webp', alt: { en: 'Arabic home page on mobile', ar: 'الصفحة الرئيسية بالعربية على الجوال' } },
        { src: '/images/projects/above-group/mobile-projects.webp', alt: { en: 'Projects on mobile', ar: 'المشاريع على الجوال' } },
      ],
    },
  },
  {
    slug: 'clinorax',
    imgSrc: '/images/projects/clinorax/cover.jpg',
    liveUrl: 'https://clinorax.b-code.tech/',
    industry: 'healthcare',
    year: '2026',
    services: ['software'],
    title: { en: 'ClinoraX', ar: 'ClinoraX' },
    tags: {
      en: ['Desktop app', 'SaaS', 'Healthcare'],
      ar: ['تطبيق سطح مكتب', 'SaaS', 'رعاية صحية'],
    },
    summary: {
      en: 'A multi-clinic management platform — a Windows desktop app that also runs as a PWA — for appointments, medical records, billing and patient leads.',
      ar: 'منصة لإدارة العيادات متعددة الفروع — تطبيق سطح مكتب لويندوز يعمل أيضاً كتطبيق ويب — للمواعيد والسجلات الطبية والفوترة والعملاء المحتملين.',
    },
    client: { en: 'B-Code product', ar: 'منتج من B-Code' },
    role: {
      en: 'Product design & full-stack development',
      ar: 'تصميم المنتج والتطوير الكامل',
    },
    overview: {
      en: 'ClinoraX is our own clinic management SaaS. Clinics run it as a Windows desktop app or in the browser, in Arabic or English, online or offline. It covers the full patient journey: booking and a drag-and-drop calendar, a live waiting-room queue, visits with diagnosis, ICD-10 codes and printed prescriptions, VAT invoices and payments, and a Kanban leads CRM — plus an agency console to onboard and manage every client clinic.',
      ar: 'ClinoraX منتجنا الخاص لإدارة العيادات بنظام SaaS. تعمل به العيادات كتطبيق سطح مكتب على ويندوز أو من المتصفح، بالعربية أو الإنجليزية، متصلاً أو دون اتصال. يغطي رحلة المريض كاملة: الحجز وتقويم بالسحب والإفلات، وقائمة انتظار مباشرة، والزيارات مع التشخيص وأكواد ICD-10 وطباعة الوصفات، وفواتير ضريبية ومدفوعات، ونظام CRM للعملاء المحتملين — إضافة إلى لوحة وكالة لإضافة وإدارة كل عيادة عميلة.',
    },
    challenge: {
      en: 'Clinics juggle paper files, spreadsheets and WhatsApp. They needed one system that works across branches and staff roles, protects medical records, keeps working when the internet drops, and is simple enough for a busy reception desk.',
      ar: 'تتعامل العيادات مع ملفات ورقية وجداول بيانات ورسائل واتساب متفرقة. كانت الحاجة إلى نظام واحد يعمل عبر الفروع وأدوار الموظفين، ويحمي السجلات الطبية، ويستمر في العمل عند انقطاع الإنترنت، ويكون سهلاً على موظفي الاستقبال المشغولين.',
    },
    solution: {
      en: 'A multi-tenant NestJS + PostgreSQL API with role-based permissions (owner, admin, doctor, receptionist), an Electron desktop app whose renderer also ships as an installable PWA, offline caching, per-device sign-in that can be revoked remotely, branch-aware invoice numbering with VAT, and an agency console for subscriptions, branch and device limits, and audit logs.',
      ar: 'واجهة برمجية متعددة المستأجرين بـ NestJS وPostgreSQL مع صلاحيات حسب الدور (مالك، مدير، طبيب، استقبال)، وتطبيق سطح مكتب بـ Electron تُنشر واجهته أيضاً كتطبيق ويب قابل للتثبيت، مع تخزين للعمل دون اتصال، وتسجيل دخول مرتبط بكل جهاز يمكن إلغاؤه عن بُعد، وترقيم فواتير لكل فرع مع ضريبة القيمة المضافة، ولوحة وكالة للاشتراكات وحدود الفروع والأجهزة وسجل التدقيق.',
    },
    results: {
      en: [
        'One system for appointments, records, billing and leads',
        'Works on Windows, in the browser, and offline',
        'Multi-branch clinics managed from one agency console',
      ],
      ar: [
        'نظام واحد للمواعيد والسجلات والفوترة والعملاء المحتملين',
        'يعمل على ويندوز وفي المتصفح ودون اتصال',
        'إدارة العيادات متعددة الفروع من لوحة وكالة واحدة',
      ],
    },
    stack: ['Electron', 'React', 'NestJS', 'PostgreSQL', 'Prisma', 'PWA', 'Arabic RTL'],
    gallery: {
      desktop: [
        { src: '/images/projects/clinorax/desktop-dashboard.webp', alt: { en: 'Dashboard on desktop', ar: 'لوحة التحكم على سطح المكتب' } },
        { src: '/images/projects/clinorax/desktop-appointments.webp', alt: { en: 'Appointments calendar', ar: 'تقويم المواعيد' } },
        { src: '/images/projects/clinorax/desktop-crm.webp', alt: { en: 'Leads CRM board', ar: 'لوحة العملاء المحتملين' } },
        { src: '/images/projects/clinorax/desktop-billing.webp', alt: { en: 'Invoices', ar: 'الفواتير' } },
      ],
      tablet: [
        { src: '/images/projects/clinorax/tablet-appointments.webp', alt: { en: 'Appointments on tablet', ar: 'المواعيد على الجهاز اللوحي' } },
      ],
      mobile: [
        { src: '/images/projects/clinorax/mobile-dashboard.webp', alt: { en: 'Dashboard on mobile', ar: 'لوحة التحكم على الجوال' } },
        { src: '/images/projects/clinorax/mobile-appointments.webp', alt: { en: 'Appointments on mobile', ar: 'المواعيد على الجوال' } },
        { src: '/images/projects/clinorax/mobile-crm.webp', alt: { en: 'Leads on mobile', ar: 'العملاء المحتملون على الجوال' } },
      ],
    },
  },
  {
    slug: 'arena',
    imgSrc: '/images/projects/arena/cover.jpg',
    liveUrl: 'https://arenause.com/',
    industry: 'services',
    year: '2026',
    services: ['software', 'web'],
    title: { en: 'Arena', ar: 'أرينا Arena' },
    tags: {
      en: ['SaaS', 'POS', 'Gaming lounges'],
      ar: ['SaaS', 'نقطة بيع', 'صالات الألعاب'],
    },
    summary: {
      en: 'A cloud platform for PlayStation and gaming lounges: live sessions, POS, bookings, shifts and reports — on any screen.',
      ar: 'منصة سحابية لصالات البلايستيشن والألعاب: جلسات مباشرة ونقطة بيع وحجوزات وورديات وتقارير — على أي شاشة.',
    },
    client: { en: 'B-Code product', ar: 'منتج من B-Code' },
    role: {
      en: 'Product design & full-stack development',
      ar: 'تصميم المنتج والتطوير الكامل',
    },
    overview: {
      en: 'Arena is our SaaS for gaming lounges in Egypt and the Arab world. Each lounge gets its own subdomain and a live board of every PlayStation, billiards table and VR station — with timers, single and multiplayer pricing, a point-of-sale for drinks and snacks, bookings and tournaments, daily shifts, customer debts and loyalty, and owner reports.',
      ar: 'أرينا منصتنا لصالات الألعاب في مصر والوطن العربي. تحصل كل صالة على نطاق فرعي خاص بها ولوحة مباشرة لكل جهاز بلايستيشن وطاولة بلياردو ومحطة VR — مع مؤقتات وتسعير فردي وجماعي، ونقطة بيع للمشروبات والوجبات الخفيفة، وحجوزات وبطولات، وورديات يومية، وديون العملاء والولاء، وتقارير للمالك.',
    },
    challenge: {
      en: 'Lounge owners lose money to untracked time, forgotten sessions and cash that does not match at the end of the shift. They needed something staff can use in seconds, that the owner can check from a phone, and that works across several branches.',
      ar: 'يخسر أصحاب الصالات أموالاً بسبب وقت غير مسجّل وجلسات منسية ونقدية لا تتطابق في نهاية الوردية. كانوا بحاجة إلى نظام يستخدمه الموظفون في ثوانٍ، ويتابعه المالك من جواله، ويعمل عبر عدة فروع.',
    },
    solution: {
      en: 'A multi-tenant Node.js + PostgreSQL platform (one schema per lounge) with a real-time React PWA: live device board, timed and open sessions, POS linked to visits, shift opening and closing, booking reminders, WhatsApp owner summaries, role permissions, and an agency console for plans, billing and lounge onboarding. It also ships as a Windows desktop app.',
      ar: 'منصة متعددة المستأجرين بـ Node.js وPostgreSQL (مخطط مستقل لكل صالة) مع تطبيق ويب React يعمل لحظياً: لوحة أجهزة مباشرة، وجلسات بوقت محدد أو مفتوح، ونقطة بيع مرتبطة بالزيارات، وفتح وإغلاق الورديات، وتذكيرات الحجوزات، وملخصات للمالك عبر واتساب، وصلاحيات حسب الدور، ولوحة وكالة للباقات والفوترة وإضافة الصالات. ويتوفر أيضاً كتطبيق سطح مكتب لويندوز.',
    },
    results: {
      en: [
        'Every device, session and sale tracked in real time',
        'Owners follow shifts and revenue from their phone',
        'New lounges onboarded on their own subdomain in minutes',
      ],
      ar: [
        'تتبّع لحظي لكل جهاز وجلسة وعملية بيع',
        'يتابع المالك الورديات والإيرادات من جواله',
        'إضافة صالات جديدة على نطاقها الفرعي خلال دقائق',
      ],
    },
    stack: ['React', 'Vite', 'PWA', 'Node.js', 'Express', 'PostgreSQL', 'Socket.IO', 'Electron'],
    gallery: {
      desktop: [
        { src: '/images/projects/arena/desktop-landing.webp', alt: { en: 'arenause.com landing page', ar: 'الصفحة الرئيسية لموقع arenause.com' } },
        { src: '/images/projects/arena/desktop-sessions.webp', alt: { en: 'Live sessions board', ar: 'لوحة الجلسات المباشرة' } },
        { src: '/images/projects/arena/desktop-pos.webp', alt: { en: 'Point of sale', ar: 'نقطة البيع' } },
        { src: '/images/projects/arena/desktop-dashboard.webp', alt: { en: 'Owner dashboard', ar: 'لوحة تحكم المالك' } },
      ],
      tablet: [
        { src: '/images/projects/arena/tablet-sessions.webp', alt: { en: 'Sessions on tablet', ar: 'الجلسات على الجهاز اللوحي' } },
      ],
      mobile: [
        { src: '/images/projects/arena/mobile-landing.webp', alt: { en: 'Landing page on mobile', ar: 'الصفحة الرئيسية على الجوال' } },
        { src: '/images/projects/arena/mobile-sessions.webp', alt: { en: 'Sessions on mobile', ar: 'الجلسات على الجوال' } },
        { src: '/images/projects/arena/mobile-pos.webp', alt: { en: 'POS on mobile', ar: 'نقطة البيع على الجوال' } },
      ],
    },
  },
  {
    slug: 'aqar-real-estate',
    imgSrc: '/images/projects/aqar-real-estate/cover.jpg',
    industry: 'real-estate',
    year: '2026',
    services: ['odoo'],
    title: { en: 'Aqar Real Estate', ar: 'عقار — نظام العقارات' },
    tags: {
      en: ['Odoo app', 'Real estate', 'Property management'],
      ar: ['تطبيق أودو', 'عقارات', 'إدارة الأملاك'],
    },
    summary: {
      en: 'A complete real estate app for Odoo — property portfolio, brokerage, rentals, development projects, client portal and website listings.',
      ar: 'تطبيق عقاري متكامل على أودو — محفظة العقارات والوساطة والإيجارات ومشاريع التطوير وبوابة العملاء وعرض العقارات على الموقع.',
    },
    client: { en: 'B-Code product', ar: 'منتج من B-Code' },
    role: {
      en: 'Odoo app design & development',
      ar: 'تصميم وتطوير تطبيق أودو',
    },
    overview: {
      en: 'Aqar is our real estate application for Odoo Enterprise. It runs both agency sales and property management in one place: buildings and units on a map, offers and visits, commission rules and splits, rental leases with recurring invoices, development projects with phases and milestones, owner statements and payouts — plus a client portal and public /properties listings with inquiry forms.',
      ar: 'عقار هو تطبيقنا العقاري على أودو إنتربرايز. يجمع مبيعات الوساطة وإدارة الأملاك في مكان واحد: المباني والوحدات على الخريطة، والعروض والمعاينات، وقواعد العمولات وتقسيمها، وعقود الإيجار بفواتير متكررة، ومشاريع التطوير بمراحلها ومعالمها، وكشوف حساب الملاك ومدفوعاتهم — إضافة إلى بوابة للعملاء وصفحة /properties لعرض العقارات مع نماذج الاستفسار.',
    },
    challenge: {
      en: 'Real estate companies usually juggle a CRM, spreadsheets for leases, a separate website for listings, and manual owner reports. Every hand-off loses leads, rent, or time — and Arabic-speaking teams and clients need it all in Arabic too.',
      ar: 'تعمل الشركات العقارية عادةً بنظام CRM منفصل وجداول بيانات للإيجارات وموقع آخر لعرض العقارات وتقارير يدوية للملاك. كل انتقال بين هذه الأدوات يُضيّع عملاء أو إيجارات أو وقتاً — وتحتاج الفرق والعملاء الناطقون بالعربية إلى كل ذلك بالعربية أيضاً.',
    },
    solution: {
      en: 'We built Aqar natively on Odoo, so it plugs straight into Accounting, CRM, Sales, Sign, Documents, Helpdesk and Appointment. Accepted offers become sales orders and can be sent for eSignature, leases invoice themselves, and compliance documents send expiry reminders. On the website, buyers and tenants browse listings with favorites, compare and a mortgage calculator, and book short-term stays — in English or Arabic.',
      ar: 'بنينا عقار داخل أودو مباشرة ليتكامل مع المحاسبة وCRM والمبيعات والتوقيع الإلكتروني والمستندات والدعم الفني والمواعيد. تتحول العروض المقبولة إلى أوامر بيع ويمكن إرسالها للتوقيع الإلكتروني، وتصدر فواتير الإيجار تلقائياً، وترسل مستندات الامتثال تذكيرات قبل انتهائها. وعلى الموقع يتصفح المشترون والمستأجرون العقارات مع المفضلة والمقارنة وحاسبة التمويل، ويحجزون الإقامات القصيرة — بالعربية أو الإنجليزية.',
    },
    results: {
      en: [
        'Sales, rentals, development and owner care in one Odoo app',
        'Public property listings and a client portal built in',
        'Full Arabic translation with right-to-left layouts',
      ],
      ar: [
        'المبيعات والإيجارات والتطوير وخدمة الملاك في تطبيق أودو واحد',
        'عرض العقارات على الموقع وبوابة للعملاء مدمجة',
        'ترجمة عربية كاملة مع تخطيط من اليمين إلى اليسار',
      ],
    },
    stack: ['Odoo Enterprise', 'Python', 'OWL', 'QWeb', 'Odoo Website', 'Odoo Sign', 'Arabic RTL'],
    odoo: {
      editions: ['enterprise'],
      versions: ['17', '18', '19', '20'],
      demoUrl: '',
      features: [
        {
          title: { en: 'Real estate analytics', ar: 'لوحة تحليلات عقارية' },
          body: {
            en: 'Occupancy, monthly rent roll, rent collected and overdue, sales closed, offer pipeline, days on market and new leads — with rent invoiced versus collected and portfolio status, filtered by period and branch.',
            ar: 'نسبة الإشغال، وإجمالي الإيجارات الشهرية، والإيجارات المحصّلة والمتأخرة، والمبيعات المنجزة، وخط العروض، ومدة بقاء العقار في السوق، والعملاء الجدد — مع مقارنة الإيجار المفوتر بالمحصّل وحالة المحفظة، حسب الفترة والفرع.',
          },
          img: '/images/projects/aqar-real-estate/dashboard.webp',
        },
        {
          title: { en: 'Property portfolio', ar: 'محفظة العقارات' },
          body: {
            en: 'Every property on a board by status — available, under offer, leased, sold — with photos, price, type and tags, plus quick filters for sale and rent.',
            ar: 'كل العقارات على لوحة حسب الحالة — متاح، أو عليه عرض، أو مؤجّر، أو مُباع — مع الصور والسعر والنوع والوسوم، وفلاتر سريعة للبيع والإيجار.',
          },
          img: '/images/projects/aqar-real-estate/properties.webp',
        },
        {
          title: { en: 'Complete property records', ar: 'سجل متكامل لكل عقار' },
          body: {
            en: 'Buildings and units with classification, agent, branch, owner and manager, pricing for sale or rent, characteristics, documents, visits, images and website publishing — all on one record.',
            ar: 'المباني والوحدات مع التصنيف والوكيل والفرع والمالك والمدير، وأسعار البيع أو الإيجار، والمواصفات، والمستندات، والمعاينات، والصور، والنشر على الموقع — كلها في سجل واحد.',
          },
          img: '/images/projects/aqar-real-estate/property-form.webp',
        },
        {
          title: { en: 'Map view', ar: 'عرض الخريطة' },
          body: {
            en: 'See the whole portfolio on a map of Saudi Arabia, with the property list beside it and a link to open any location in Google Maps.',
            ar: 'اعرض المحفظة كاملة على خريطة المملكة، مع قائمة العقارات بجانبها ورابط لفتح أي موقع في خرائط Google.',
          },
          img: '/images/projects/aqar-real-estate/map.webp',
        },
        {
          title: { en: 'Rental leases', ar: 'عقود الإيجار' },
          body: {
            en: 'Leases with tenant and co-tenants, term, rent, deposit, service charges, billing day and recurrence — from draft and signature to active, renewed or terminated.',
            ar: 'عقود إيجار تتضمن المستأجر والمستأجرين المشاركين، والمدة، والإيجار، والتأمين، ورسوم الخدمات، ويوم الفوترة والتكرار — من المسودة والتوقيع إلى السريان أو التجديد أو الإنهاء.',
          },
          img: '/images/projects/aqar-real-estate/lease-form.webp',
        },
        {
          title: { en: 'Automatic rent invoicing', ar: 'فوترة الإيجار تلقائياً' },
          body: {
            en: 'Rent invoices are created on schedule from each lease and tracked through payment, with due dates and follow-ups so overdue rent is never missed.',
            ar: 'تُصدر فواتير الإيجار تلقائياً حسب جدول كل عقد وتُتابع حتى السداد، مع تواريخ الاستحقاق والمتابعة حتى لا يفوتك أي إيجار متأخر.',
          },
          img: '/images/projects/aqar-real-estate/rental-invoices.webp',
        },
        {
          title: { en: 'Owner statements and payouts', ar: 'كشوف حساب الملاك ومدفوعاتهم' },
          body: {
            en: 'Monthly statements per owner with rent collected, management fees, expenses and the net payable — then create the payout bill in one click.',
            ar: 'كشف شهري لكل مالك بالإيجارات المحصّلة ورسوم الإدارة والمصروفات وصافي المستحق — ثم إنشاء فاتورة الدفع بنقرة واحدة.',
          },
          img: '/images/projects/aqar-real-estate/owner-statement-form.webp',
        },
        {
          title: { en: 'Development projects', ar: 'مشاريع التطوير' },
          body: {
            en: 'Track each project from planning and permitting to construction, selling and completion, with budget versus spend, phases, milestones, and units generated straight into the portfolio.',
            ar: 'تابع كل مشروع من التخطيط والترخيص إلى الإنشاء والبيع والتسليم، مع الميزانية مقابل المصروف، والمراحل، والمعالم، وتوليد الوحدات مباشرة في المحفظة.',
          },
          img: '/images/projects/aqar-real-estate/development-form.webp',
        },
        {
          title: { en: 'Offers and sales brokerage', ar: 'العروض والوساطة في البيع' },
          body: {
            en: 'Every offer with price, validity and agent, accepted or refused in one click — accepted offers become sales orders and can be sent for eSignature.',
            ar: 'كل عرض بسعره ومدة صلاحيته ووكيله، يُقبل أو يُرفض بنقرة — وتتحوّل العروض المقبولة إلى أوامر بيع ويمكن إرسالها للتوقيع الإلكتروني.',
          },
          img: '/images/projects/aqar-real-estate/offers.webp',
        },
        {
          title: { en: 'Agent commissions', ar: 'عمولات الوكلاء' },
          body: {
            en: 'Commission rules by agent role, with commission lines calculated automatically for listing and buyer agents and splits across the team.',
            ar: 'قواعد عمولات حسب دور الوكيل، مع احتساب سطور العمولة تلقائياً لوكيل العرض ووكيل المشتري وتقسيمها على الفريق.',
          },
          img: '/images/projects/aqar-real-estate/commissions.webp',
        },
        {
          title: { en: 'Inquiries pipeline', ar: 'مسار الاستفسارات' },
          body: {
            en: 'Website inquiries and leads land in a CRM pipeline linked to the property — from new to qualified, proposition and won.',
            ar: 'تصل استفسارات الموقع والعملاء المحتملون إلى مسار CRM مرتبط بالعقار — من جديد إلى مؤهَّل ثم عرض ثم صفقة ناجحة.',
          },
          img: '/images/projects/aqar-real-estate/pipeline.webp',
        },
        {
          title: { en: 'Compliance documents', ar: 'مستندات الامتثال' },
          body: {
            en: 'Insurance policies, building permits and civil-defence certificates per property, with expiry tracking and reminders before anything lapses.',
            ar: 'وثائق التأمين وتصاريح البناء وشهادات الدفاع المدني لكل عقار، مع تتبّع تواريخ الانتهاء وتذكيرات قبل انتهاء أي مستند.',
          },
          img: '/images/projects/aqar-real-estate/documents.webp',
        },
      ],
      screens: [
        { src: '/images/projects/aqar-real-estate/dashboard.webp', title: { en: 'Dashboard', ar: 'لوحة التحكم' } },
        { src: '/images/projects/aqar-real-estate/properties.webp', title: { en: 'Properties › All Properties', ar: 'العقارات › جميع العقارات' } },
        { src: '/images/projects/aqar-real-estate/property-form.webp', title: { en: 'Property record', ar: 'سجل العقار' } },
        { src: '/images/projects/aqar-real-estate/for-sale.webp', title: { en: 'Properties › For Sale', ar: 'العقارات › للبيع' } },
        { src: '/images/projects/aqar-real-estate/for-rent.webp', title: { en: 'Properties › For Rent', ar: 'العقارات › للإيجار' } },
        { src: '/images/projects/aqar-real-estate/map.webp', title: { en: 'Properties › Map View', ar: 'العقارات › الخريطة' } },
        { src: '/images/projects/aqar-real-estate/owners.webp', title: { en: 'Properties › Owners', ar: 'العقارات › الملاك' } },
        { src: '/images/projects/aqar-real-estate/leases.webp', title: { en: 'Rentals › Leases', ar: 'الإيجارات › العقود' } },
        { src: '/images/projects/aqar-real-estate/lease-form.webp', title: { en: 'Lease', ar: 'عقد إيجار' } },
        { src: '/images/projects/aqar-real-estate/rental-invoices.webp', title: { en: 'Rentals › Rental Invoices', ar: 'الإيجارات › فواتير الإيجار' } },
        { src: '/images/projects/aqar-real-estate/owner-statements.webp', title: { en: 'Rentals › Owner Statements', ar: 'الإيجارات › كشوف الملاك' } },
        { src: '/images/projects/aqar-real-estate/owner-statement-form.webp', title: { en: 'Owner statement', ar: 'كشف حساب مالك' } },
        { src: '/images/projects/aqar-real-estate/tenants.webp', title: { en: 'Rentals › Tenants', ar: 'الإيجارات › المستأجرون' } },
        { src: '/images/projects/aqar-real-estate/development.webp', title: { en: 'Development › Projects', ar: 'التطوير › المشاريع' } },
        { src: '/images/projects/aqar-real-estate/development-form.webp', title: { en: 'Development project', ar: 'مشروع تطوير' } },
        { src: '/images/projects/aqar-real-estate/offers.webp', title: { en: 'Brokerage › Offers', ar: 'الوساطة › العروض' } },
        { src: '/images/projects/aqar-real-estate/offer-form.webp', title: { en: 'Offer', ar: 'عرض شراء' } },
        { src: '/images/projects/aqar-real-estate/commissions.webp', title: { en: 'Brokerage › Commissions', ar: 'الوساطة › العمولات' } },
        { src: '/images/projects/aqar-real-estate/buyers.webp', title: { en: 'Brokerage › Buyers', ar: 'الوساطة › المشترون' } },
        { src: '/images/projects/aqar-real-estate/pipeline.webp', title: { en: 'Brokerage › Inquiries Pipeline', ar: 'الوساطة › مسار الاستفسارات' } },
        { src: '/images/projects/aqar-real-estate/documents.webp', title: { en: 'Documents › All Documents', ar: 'المستندات › جميع المستندات' } },
        { src: '/images/projects/aqar-real-estate/documents-expired.webp', title: { en: 'Documents › Expired', ar: 'المستندات › المنتهية' } },
        { src: '/images/projects/aqar-real-estate/property-types.webp', title: { en: 'Configuration › Property Types', ar: 'الإعدادات › أنواع العقارات' } },
        { src: '/images/projects/aqar-real-estate/tags.webp', title: { en: 'Configuration › Tags', ar: 'الإعدادات › الوسوم' } },
        { src: '/images/projects/aqar-real-estate/commission-rules.webp', title: { en: 'Configuration › Commission Rules', ar: 'الإعدادات › قواعد العمولات' } },
        { src: '/images/projects/aqar-real-estate/branches.webp', title: { en: 'Configuration › Branches', ar: 'الإعدادات › الفروع' } },
      ],
    },
  },
  {
    slug: 'horizon-dashboard',
    imgSrc: '/images/projects/horizon-dashboard/cover.jpg',
    industry: 'ecommerce',
    year: '2026',
    services: ['odoo'],
    title: { en: 'Horizon Dashboard', ar: 'لوحة Horizon' },
    tags: {
      en: ['Odoo app', 'Business intelligence', 'Retail'],
      ar: ['تطبيق أودو', 'ذكاء الأعمال', 'التجزئة'],
    },
    summary: {
      en: 'A business intelligence app for Odoo with live dashboards for sales, inventory, customers, retail, finance and point of sale.',
      ar: 'تطبيق ذكاء أعمال على أودو بلوحات مباشرة للمبيعات والمخزون والعملاء والتجزئة والمالية ونقاط البيع.',
    },
    client: { en: 'B-Code product', ar: 'منتج من B-Code' },
    role: {
      en: 'Odoo app design & development',
      ar: 'تصميم وتطوير تطبيق أودو',
    },
    overview: {
      en: 'Horizon brings a full analytics suite inside Odoo. Managers move between Overview, Sales, Inventory, Customers, Retail, Finance, Point of Sale and Insights pages from one sidebar, with filters for date range, company, branch, salesperson, category and currency that follow them across every page.',
      ar: 'يقدّم Horizon منظومة تحليلات كاملة داخل أودو. ينتقل المديرون بين صفحات النظرة العامة والمبيعات والمخزون والعملاء والتجزئة والمالية ونقاط البيع والرؤى من قائمة جانبية واحدة، مع فلاتر للفترة والشركة والفرع ومندوب المبيعات والفئة والعملة تبقى معهم في كل صفحة.',
    },
    challenge: {
      en: 'Retailers with several branches had the data in Odoo but no clear view of it. Answers to simple questions — which branch is growing, which products are running out, which customers are slipping away — meant exporting to spreadsheets every week.',
      ar: 'كانت بيانات تجار التجزئة متعددي الفروع موجودة في أودو، لكن دون رؤية واضحة لها. الإجابة عن أسئلة بسيطة — أي فرع ينمو، وأي المنتجات توشك على النفاد، وأي العملاء بدأوا بالابتعاد — كانت تعني التصدير إلى جداول البيانات كل أسبوع.',
    },
    solution: {
      en: 'Every metric is computed server-side from real Odoo data — nothing is estimated or faked; if data is missing, the widget says so. Charts cover retail KPIs, RFM and customer lifetime value, ABC product ranking and stock alerts, and a rule-based engine raises insights and alerts. Admins configure pages, tabs, widgets, thresholds, permissions and themes without code.',
      ar: 'يُحسب كل مؤشر على الخادم من بيانات أودو الفعلية — لا تقديرات ولا أرقام وهمية؛ وإذا غابت البيانات تُظهر الأداة ذلك بوضوح. تغطي الرسوم مؤشرات التجزئة وتحليل RFM والقيمة الدائمة للعميل وتصنيف ABC للمنتجات وتنبيهات المخزون، ويُصدر محرك قواعد رؤى وتنبيهات تلقائية. ويضبط المسؤولون الصفحات والتبويبات والأدوات والحدود والصلاحيات والسمات دون كتابة كود.',
    },
    results: {
      en: [
        '8 analytics pages built on live Odoo data',
        'Branch, category and salesperson filters across every page',
        'Dashboards, thresholds and themes configurable without code',
      ],
      ar: [
        '8 صفحات تحليلية مبنية على بيانات أودو المباشرة',
        'فلاتر للفرع والفئة ومندوب المبيعات في كل الصفحات',
        'لوحات وحدود وسمات قابلة للتخصيص دون كود',
      ],
    },
    stack: ['Odoo', 'Python', 'OWL', 'Chart.js', 'Point of Sale', 'Arabic RTL'],
    odoo: {
      editions: ['enterprise'],
      versions: ['17', '18', '19', '20'],
      demoUrl: '',
      features: [
        {
          title: { en: 'Executive overview', ar: 'نظرة تنفيذية شاملة' },
          body: {
            en: 'Revenue, orders, gross profit and margin, average transaction, units sold and returns at a glance — each compared with the previous period — with revenue split by branch, product, salesperson and category.',
            ar: 'الإيرادات والطلبات والربح الإجمالي والهامش ومتوسط قيمة العملية والوحدات المباعة والمرتجعات في لمحة واحدة — مع مقارنة كل منها بالفترة السابقة — وتوزيع الإيرادات حسب الفرع والمنتج ومندوب المبيعات والفئة.',
          },
          img: '/images/projects/horizon-dashboard/overview.webp',
        },
        {
          title: { en: 'Point of Sale analytics', ar: 'تحليلات نقاط البيع' },
          body: {
            en: 'POS revenue, orders, average basket and returns, a six-month revenue trend, payment-method mix, and revenue by branch, cashier and category — plus live session and product tabs.',
            ar: 'إيرادات نقاط البيع والطلبات ومتوسط السلة والمرتجعات، واتجاه الإيرادات لستة أشهر، وتوزيع طرق الدفع، والإيرادات حسب الفرع والكاشير والفئة — مع تبويبات للجلسات والمنتجات.',
          },
          img: '/images/projects/horizon-dashboard/pos-overview.webp',
        },
        {
          title: { en: 'Sales performance', ar: 'أداء المبيعات' },
          body: {
            en: 'Revenue and order trends over the last six months, with the same KPI strip filtered by company, branch, salesperson and category.',
            ar: 'اتجاهات الإيرادات والطلبات خلال آخر ستة أشهر، مع شريط المؤشرات نفسه مفلتراً حسب الشركة والفرع ومندوب المبيعات والفئة.',
          },
          img: '/images/projects/horizon-dashboard/sales-performance.webp',
        },
        {
          title: { en: 'Branch comparison', ar: 'مقارنة الفروع' },
          body: {
            en: 'Rank branches by revenue, orders and average ticket, and compare revenue and estimated profit side by side to see which store is growing.',
            ar: 'رتّب الفروع حسب الإيرادات والطلبات ومتوسط الفاتورة، وقارن الإيرادات والأرباح التقديرية جنباً إلى جنب لتعرف أي فرع ينمو.',
          },
          img: '/images/projects/horizon-dashboard/sales-branches.webp',
        },
        {
          title: { en: 'Products and categories', ar: 'المنتجات والفئات' },
          body: {
            en: 'Top and bottom products, strongest growth, and revenue, units and gross margin by category — so you know what to reorder and what to discount.',
            ar: 'أفضل المنتجات وأضعفها والأسرع نمواً، والإيرادات والوحدات والهامش الإجمالي حسب الفئة — لتعرف ما تعيد طلبه وما تخفّض سعره.',
          },
          img: '/images/projects/horizon-dashboard/sales-categories.webp',
        },
        {
          title: { en: 'Inventory and stock health', ar: 'المخزون وصحة المخزون' },
          body: {
            en: 'Available, reserved, incoming and outgoing stock with its value by category and branch, and every product classed as healthy, low, out of stock, overstock, slow-moving or dead stock.',
            ar: 'المخزون المتاح والمحجوز والوارد والصادر وقيمته حسب الفئة والفرع، مع تصنيف كل منتج: سليم أو منخفض أو نافد أو زائد أو بطيء الحركة أو راكد.',
          },
          img: '/images/projects/horizon-dashboard/inventory-stock-health.webp',
        },
        {
          title: { en: 'Stock alerts', ar: 'تنبيهات المخزون' },
          body: {
            en: 'A prioritised list of items running low in each branch, with alert counts per branch — before customers find empty shelves.',
            ar: 'قائمة مرتّبة حسب الأولوية بالأصناف التي توشك على النفاد في كل فرع، مع عدد التنبيهات لكل فرع — قبل أن يجد العملاء الرفوف فارغة.',
          },
          img: '/images/projects/horizon-dashboard/inventory-alerts.webp',
        },
        {
          title: { en: 'Customer segments and RFM', ar: 'شرائح العملاء وتحليل RFM' },
          body: {
            en: 'New versus returning customers, average order value and purchase frequency, and RFM segments — champions, loyal, at risk, inactive — with the revenue each one brings.',
            ar: 'العملاء الجدد مقابل العائدين، ومتوسط قيمة الطلب وتكرار الشراء، وشرائح RFM — الأبطال والأوفياء والمعرّضون للفقد وغير النشطين — مع إيرادات كل شريحة.',
          },
          img: '/images/projects/horizon-dashboard/customers-segments.webp',
        },
        {
          title: { en: 'Retail KPIs', ar: 'مؤشرات التجزئة' },
          body: {
            en: 'Sell-through rate, units per transaction, average ticket, inventory turnover and GMROI for every branch, with clear notes on how each one is calculated.',
            ar: 'معدل البيع، والوحدات لكل عملية، ومتوسط الفاتورة، ودوران المخزون، والعائد على الاستثمار في المخزون (GMROI) لكل فرع، مع توضيح طريقة حساب كل مؤشر.',
          },
          img: '/images/projects/horizon-dashboard/retail-kpis.webp',
        },
        {
          title: { en: 'Product intelligence', ar: 'ذكاء المنتجات' },
          body: {
            en: 'Products customers buy together, cross-sell attach rates, size curves and markdown penetration — ideas for bundles, displays and smarter buying.',
            ar: 'المنتجات التي يشتريها العملاء معاً، ومعدلات البيع المتقاطع، ومنحنيات المقاسات، ونسبة البيع بالتخفيض — أفكار للعروض المجمّعة والعرض في المتجر والشراء بذكاء.',
          },
          img: '/images/projects/horizon-dashboard/retail-product-intelligence.webp',
        },
        {
          title: { en: 'Expenses and cash flow', ar: 'المصروفات والتدفق النقدي' },
          body: {
            en: 'Operating expenses by account with a six-month trend, and cash in versus cash out with net cash flow — straight from posted accounting entries.',
            ar: 'المصروفات التشغيلية حسب الحساب مع اتجاه لستة أشهر، والنقد الداخل مقابل الخارج مع صافي التدفق النقدي — مباشرة من القيود المحاسبية المرحّلة.',
          },
          img: '/images/projects/horizon-dashboard/finance-cash-flow.webp',
        },
        {
          title: { en: 'Insights and alerts', ar: 'رؤى وتنبيهات تلقائية' },
          body: {
            en: 'A rule-based engine reads your real data and flags what needs attention — products critically low on stock, thin margins, sharp revenue changes.',
            ar: 'محرك قواعد يقرأ بياناتك الفعلية وينبّهك لما يحتاج إلى متابعة — منتجات منخفضة المخزون بشدة، وهوامش ضعيفة، وتغيّرات حادة في الإيرادات.',
          },
          img: '/images/projects/horizon-dashboard/insights.webp',
        },
        {
          title: { en: 'Theme studio', ar: 'استوديو السمات' },
          body: {
            en: 'Six built-in themes, light and dark, and a colour editor to match your brand — every chart and card updates instantly.',
            ar: 'ست سمات جاهزة بين الفاتح والداكن، ومحرر ألوان لمطابقة هويتك — وتتحدث كل الرسوم والبطاقات فوراً.',
          },
          img: '/images/projects/horizon-dashboard/config-colors.webp',
        },
        {
          title: { en: 'Pages, visibility and permissions', ar: 'الصفحات والظهور والصلاحيات' },
          body: {
            en: 'Reorder pages and tabs by drag and drop, choose who sees each one, set stock thresholds, and assign users, managers and administrators — all without code.',
            ar: 'أعد ترتيب الصفحات والتبويبات بالسحب والإفلات، وحدّد من يرى كلاً منها، واضبط حدود المخزون، ووزّع المستخدمين والمديرين والمسؤولين — دون أي كود.',
          },
          img: '/images/projects/horizon-dashboard/config-permissions.webp',
        },
      ],
      screens: [
        { src: '/images/projects/horizon-dashboard/overview.webp', title: { en: 'Overview', ar: 'النظرة العامة' } },
        { src: '/images/projects/horizon-dashboard/pos-overview.webp', title: { en: 'Point of Sale › Overview', ar: 'نقاط البيع › نظرة عامة' } },
        { src: '/images/projects/horizon-dashboard/pos-sessions.webp', title: { en: 'Point of Sale › Sessions', ar: 'نقاط البيع › الجلسات' } },
        { src: '/images/projects/horizon-dashboard/pos-products.webp', title: { en: 'Point of Sale › Products', ar: 'نقاط البيع › المنتجات' } },
        { src: '/images/projects/horizon-dashboard/sales-performance.webp', title: { en: 'Sales › Performance', ar: 'المبيعات › الأداء' } },
        { src: '/images/projects/horizon-dashboard/sales-branches.webp', title: { en: 'Sales › Branches', ar: 'المبيعات › الفروع' } },
        { src: '/images/projects/horizon-dashboard/sales-products.webp', title: { en: 'Sales › Products', ar: 'المبيعات › المنتجات' } },
        { src: '/images/projects/horizon-dashboard/sales-categories.webp', title: { en: 'Sales › Categories', ar: 'المبيعات › الفئات' } },
        { src: '/images/projects/horizon-dashboard/sales-employees.webp', title: { en: 'Sales › Employees', ar: 'المبيعات › الموظفون' } },
        { src: '/images/projects/horizon-dashboard/inventory-overview.webp', title: { en: 'Inventory › Overview', ar: 'المخزون › نظرة عامة' } },
        { src: '/images/projects/horizon-dashboard/inventory-stock-health.webp', title: { en: 'Inventory › Stock Health', ar: 'المخزون › صحة المخزون' } },
        { src: '/images/projects/horizon-dashboard/inventory-products.webp', title: { en: 'Inventory › Products', ar: 'المخزون › المنتجات' } },
        { src: '/images/projects/horizon-dashboard/inventory-alerts.webp', title: { en: 'Inventory › Alerts', ar: 'المخزون › التنبيهات' } },
        { src: '/images/projects/horizon-dashboard/customers-overview.webp', title: { en: 'Customers › Overview', ar: 'العملاء › نظرة عامة' } },
        { src: '/images/projects/horizon-dashboard/customers-segments.webp', title: { en: 'Customers › Segments', ar: 'العملاء › الشرائح' } },
        { src: '/images/projects/horizon-dashboard/retail-kpis.webp', title: { en: 'Retail › KPIs', ar: 'التجزئة › المؤشرات' } },
        { src: '/images/projects/horizon-dashboard/retail-product-intelligence.webp', title: { en: 'Retail › Product Intelligence', ar: 'التجزئة › ذكاء المنتجات' } },
        { src: '/images/projects/horizon-dashboard/retail-store-efficiency.webp', title: { en: 'Retail › Store Efficiency', ar: 'التجزئة › كفاءة المتاجر' } },
        { src: '/images/projects/horizon-dashboard/finance-expenses.webp', title: { en: 'Finance › Expenses', ar: 'المالية › المصروفات' } },
        { src: '/images/projects/horizon-dashboard/finance-cash-flow.webp', title: { en: 'Finance › Cash Flow', ar: 'المالية › التدفق النقدي' } },
        { src: '/images/projects/horizon-dashboard/insights.webp', title: { en: 'Insights', ar: 'الرؤى' } },
        { src: '/images/projects/horizon-dashboard/config-dashboard.webp', title: { en: 'Configuration › Dashboard order', ar: 'الإعدادات › ترتيب اللوحة' } },
        { src: '/images/projects/horizon-dashboard/config-visibility.webp', title: { en: 'Configuration › Visibility', ar: 'الإعدادات › الظهور' } },
        { src: '/images/projects/horizon-dashboard/config-themes.webp', title: { en: 'Configuration › Themes', ar: 'الإعدادات › السمات' } },
        { src: '/images/projects/horizon-dashboard/config-colors.webp', title: { en: 'Configuration › Colors', ar: 'الإعدادات › الألوان' } },
        { src: '/images/projects/horizon-dashboard/config-thresholds.webp', title: { en: 'Configuration › Thresholds', ar: 'الإعدادات › الحدود' } },
        { src: '/images/projects/horizon-dashboard/config-permissions.webp', title: { en: 'Configuration › Permissions', ar: 'الإعدادات › الصلاحيات' } },
        { src: '/images/projects/horizon-dashboard/cfg-dashboards.webp', title: { en: 'Dashboard configurations', ar: 'إعدادات اللوحات' } },
        { src: '/images/projects/horizon-dashboard/cfg-pages.webp', title: { en: 'Pages', ar: 'الصفحات' } },
        { src: '/images/projects/horizon-dashboard/cfg-tabs.webp', title: { en: 'Tabs', ar: 'التبويبات' } },
        { src: '/images/projects/horizon-dashboard/cfg-themes.webp', title: { en: 'Themes', ar: 'السمات' } },
      ],
    },
  },
  {
    slug: 'performance-hub',
    imgSrc: '/images/projects/performance-hub/cover.jpg',
    industry: 'services',
    year: '2026',
    services: ['odoo'],
    title: { en: 'Performance Hub', ar: 'Performance Hub' },
    tags: {
      en: ['Odoo app', 'HR', 'KPI scoring'],
      ar: ['تطبيق أودو', 'الموارد البشرية', 'مؤشرات الأداء'],
    },
    summary: {
      en: 'An Odoo app that scores developers and implementors automatically from their tasks, timesheets and attendance — with leaderboards and badges.',
      ar: 'تطبيق على أودو يقيّم المطورين ومستشاري التطبيق تلقائياً من مهامهم وسجلات وقتهم وحضورهم — مع لوحات ترتيب وشارات.',
    },
    client: { en: 'B-Code product', ar: 'منتج من B-Code' },
    role: {
      en: 'Odoo app design & development',
      ar: 'تصميم وتطوير تطبيق أودو',
    },
    overview: {
      en: 'Performance Hub turns everyday project work into a fair, transparent KPI score. It connects Odoo HR, Projects, Timesheets, Time Off and Attendance, awards or deducts points as work happens, and shows each person their score, rank and badge on a modern analytics dashboard.',
      ar: 'يحوّل Performance Hub العمل اليومي على المشاريع إلى درجة أداء عادلة وشفافة. يربط الموارد البشرية والمشاريع وسجلات الوقت والإجازات والحضور في أودو، ويمنح النقاط أو يخصمها أثناء العمل، ويعرض لكل موظف درجته وترتيبه وشارته على لوحة تحليلات حديثة.',
    },
    challenge: {
      en: 'Software and implementation teams were judged on gut feeling and monthly spreadsheets. Missed deadlines, missing estimates and unlogged hours were noticed late, and good work was hard to prove.',
      ar: 'كان تقييم فرق التطوير والتطبيق يعتمد على الانطباع وجداول البيانات الشهرية. كانت المواعيد الفائتة والتقديرات الناقصة والساعات غير المسجلة تُكتشف متأخرة، وكان إثبات العمل الجيد صعباً.',
    },
    solution: {
      en: 'Over 30 configurable rules, split for developers and implementors, score work automatically when tasks change stage, hit or miss deadlines, log timesheets or report bugs, and weekly jobs check attendance and hour targets. Scores run in periods with gold, silver and bronze badges; closed periods lock for audit. Employees see their own results, while managers get team leaderboards, PDF and CSV reports, and a list of tasks to fix.',
      ar: 'أكثر من 30 قاعدة قابلة للتخصيص، منفصلة للمطورين ومستشاري التطبيق، تحتسب النقاط تلقائياً عند انتقال المهام بين المراحل أو الالتزام بالمواعيد أو تفويتها أو تسجيل الوقت أو الإبلاغ عن الأخطاء، ومهام أسبوعية تراجع الحضور وأهداف الساعات. تُحتسب الدرجات على فترات بشارات ذهبية وفضية وبرونزية، وتُقفل الفترات المغلقة للتدقيق. يرى الموظف نتائجه فقط، بينما يحصل المديرون على ترتيب الفريق وتقارير PDF وCSV وقائمة بالمهام التي تحتاج إلى تصحيح.',
    },
    results: {
      en: [
        '30+ ready-made KPI rules for developers and implementors',
        'Scores update automatically from real project work',
        'Leaderboards, badges and locked periods for fair reviews',
      ],
      ar: [
        'أكثر من 30 قاعدة أداء جاهزة للمطورين ومستشاري التطبيق',
        'تحديث الدرجات تلقائياً من العمل الفعلي على المشاريع',
        'لوحات ترتيب وشارات وفترات مقفلة لتقييم عادل',
      ],
    },
    stack: ['Odoo', 'Python', 'OWL', 'Chart.js', 'Odoo Project', 'Timesheets', 'Attendance'],
    odoo: {
      editions: ['enterprise'],
      versions: ['17', '18', '19', '20'],
      demoUrl: '',
      features: [
        {
          title: { en: 'Analytics dashboard', ar: 'لوحة تحليلات متكاملة' },
          body: {
            en: 'One screen for the whole team: combined, positive and negative points, on-time tasks, timesheet compliance, weekly trend, points mix and top rules — for any period, with a picker to drill into one employee.',
            ar: 'شاشة واحدة للفريق بأكمله: مجموع النقاط الإيجابية والسلبية، والمهام المنجزة في وقتها، والالتزام بسجلات الوقت، والاتجاه الأسبوعي، وتوزيع النقاط وأبرز القواعد — لأي فترة، مع إمكانية التركيز على موظف واحد.',
          },
          img: '/images/projects/performance-hub/dashboard.webp',
        },
        {
          title: { en: 'Leaderboards and live activity', ar: 'لوحات الترتيب والنشاط المباشر' },
          body: {
            en: 'Employees are ranked by points with gold, silver and bronze badges, next to the rules that earned the most points and a live feed of every score as it happens.',
            ar: 'يُرتَّب الموظفون حسب النقاط مع شارات ذهبية وفضية وبرونزية، إلى جانب القواعد الأكثر تحقيقاً للنقاط وسجل مباشر لكل نقطة لحظة احتسابها.',
          },
          img: '/images/projects/performance-hub/dashboard-leaderboard.webp',
        },
        {
          title: { en: 'Scoring that runs itself', ar: 'احتساب تلقائي للنقاط' },
          body: {
            en: 'Points are created automatically when a task moves stage, meets or misses its deadline, logs time or reports a bug. Every automatic score is marked as such and keeps a full audit log of changes.',
            ar: 'تُحتسب النقاط تلقائياً عند انتقال المهمة بين المراحل، أو الالتزام بموعدها أو تفويته، أو تسجيل الوقت، أو الإبلاغ عن خطأ. وكل نقطة تلقائية مميّزة بوضوح ولها سجل تدقيق كامل للتعديلات.',
          },
          img: '/images/projects/performance-hub/score-form.webp',
        },
        {
          title: { en: 'Personal summary, rank and badge', ar: 'ملخص شخصي وترتيب وشارة' },
          body: {
            en: 'Each employee gets a summary for the period: total, positive and negative points, rank and badge, with every score split into tabs — and one-click PDF, CSV or email.',
            ar: 'يحصل كل موظف على ملخص للفترة: إجمالي النقاط الإيجابية والسلبية والترتيب والشارة، مع تقسيم كل النقاط في تبويبات — وتصدير PDF أو CSV أو إرسال بالبريد بنقرة واحدة.',
          },
          img: '/images/projects/performance-hub/summary-form.webp',
        },
        {
          title: { en: '30+ configurable KPI rules', ar: 'أكثر من 30 قاعدة أداء قابلة للتخصيص' },
          body: {
            en: 'Ready-made positive and negative rules for developers, implementors or all roles — deadlines, task complexity, timesheet targets, attendance, time off and more. Managers change points without touching code.',
            ar: 'قواعد جاهزة إيجابية وسلبية للمطورين أو مستشاري التطبيق أو لكل الأدوار — المواعيد، وتعقيد المهام، وأهداف سجلات الوقت، والحضور، والإجازات وغيرها. ويعدّل المديرون النقاط دون كتابة كود.',
          },
          img: '/images/projects/performance-hub/rules.webp',
        },
        {
          title: { en: 'Built into Odoo Project', ar: 'مدمج داخل مشاريع أودو' },
          body: {
            en: 'Tasks gain Developer, Implementor and Assistants fields, task type, complexity, priority and bug flags, plus a KPI Scores button — so scoring follows the work your team already does in Odoo.',
            ar: 'تُضاف إلى المهام حقول المطوّر ومستشار التطبيق والمساعدين، ونوع المهمة ودرجة تعقيدها والأولوية وعلامة الخطأ، مع زر لنقاط الأداء — فيتبع التقييم العمل الذي ينجزه فريقك أصلاً في أودو.',
          },
          img: '/images/projects/performance-hub/task-form.webp',
        },
        {
          title: { en: 'Scoring periods with locked results', ar: 'فترات تقييم بنتائج مقفلة' },
          body: {
            en: 'Scores run in monthly or custom periods. Closing a period recomputes rankings, posts the top performers and locks every score so final results can no longer change.',
            ar: 'تُحتسب النقاط على فترات شهرية أو مخصّصة. وعند إغلاق الفترة يُعاد احتساب الترتيب، ويُنشر أفضل الموظفين، وتُقفل كل النقاط فلا يمكن تغيير النتائج النهائية.',
          },
          img: '/images/projects/performance-hub/period-form.webp',
        },
        {
          title: { en: 'Manager analysis', ar: 'تحليلات للمديرين' },
          body: {
            en: 'Rankings by employee, period and rule in list, pivot and graph views — export to a spreadsheet or compare months side by side.',
            ar: 'ترتيب حسب الموظف والفترة والقاعدة في عروض القائمة والجدول المحوري والرسم البياني — مع التصدير إلى جداول البيانات أو مقارنة الأشهر جنباً إلى جنب.',
          },
          img: '/images/projects/performance-hub/employee-rankings.webp',
        },
        {
          title: { en: 'Settings and automation', ar: 'الإعدادات والأتمتة' },
          body: {
            en: 'Choose the KPI month window, turn automatic scoring on or off, prefer stage-based triggers, score task assistants, and set the weekly timesheet targets checked every week.',
            ar: 'حدّد نافذة الشهر للتقييم، وفعّل الاحتساب التلقائي أو أوقفه، واعتمد على مراحل المهام كمحفّزات، واحتسب نقاط مساعدي المهام، واضبط أهداف سجلات الوقت التي تُراجع أسبوعياً.',
          },
          img: '/images/projects/performance-hub/settings.webp',
        },
      ],
      screens: [
        { src: '/images/projects/performance-hub/dashboard.webp', title: { en: 'Dashboard — team KPIs', ar: 'لوحة التحكم — مؤشرات الفريق' } },
        { src: '/images/projects/performance-hub/dashboard-leaderboard.webp', title: { en: 'Dashboard — leaderboard and activity', ar: 'لوحة التحكم — الترتيب والنشاط' } },
        { src: '/images/projects/performance-hub/summary.webp', title: { en: 'Performance › Summary', ar: 'الأداء › الملخص' } },
        { src: '/images/projects/performance-hub/summary-form.webp', title: { en: 'Employee summary', ar: 'ملخص الموظف' } },
        { src: '/images/projects/performance-hub/score-lines.webp', title: { en: 'Performance › Score Lines', ar: 'الأداء › سطور النقاط' } },
        { src: '/images/projects/performance-hub/score-form.webp', title: { en: 'Score line with audit log', ar: 'سطر نقاط مع سجل التدقيق' } },
        { src: '/images/projects/performance-hub/tasks-to-fix.webp', title: { en: 'Performance › Tasks to Fix', ar: 'الأداء › مهام تحتاج إلى تصحيح' } },
        { src: '/images/projects/performance-hub/task-form.webp', title: { en: 'Project task with KPI fields', ar: 'مهمة مشروع مع حقول الأداء' } },
        { src: '/images/projects/performance-hub/employee-rankings.webp', title: { en: 'Analysis › Employee Rankings', ar: 'التحليل › ترتيب الموظفين' } },
        { src: '/images/projects/performance-hub/period-breakdown.webp', title: { en: 'Analysis › Period Breakdown', ar: 'التحليل › تفصيل الفترات' } },
        { src: '/images/projects/performance-hub/rule-breakdown.webp', title: { en: 'Analysis › Rule Breakdown', ar: 'التحليل › تفصيل القواعد' } },
        { src: '/images/projects/performance-hub/rules.webp', title: { en: 'Configuration › Rules', ar: 'الإعدادات › القواعد' } },
        { src: '/images/projects/performance-hub/rule-form.webp', title: { en: 'KPI rule', ar: 'قاعدة أداء' } },
        { src: '/images/projects/performance-hub/periods.webp', title: { en: 'Configuration › Periods', ar: 'الإعدادات › الفترات' } },
        { src: '/images/projects/performance-hub/period-form.webp', title: { en: 'Closed period with top performers', ar: 'فترة مغلقة مع أفضل الموظفين' } },
        { src: '/images/projects/performance-hub/settings.webp', title: { en: 'Configuration › Settings', ar: 'الإعدادات › الضبط' } },
        { src: '/images/projects/performance-hub/task-stages.webp', title: { en: 'Configuration › Task Stages', ar: 'الإعدادات › مراحل المهام' } },
      ],
    },
  },
  {
    slug: 'aisha-academy',
    imgSrc: '/images/projects/aisha-academy/cover.jpg',
    liveUrl: 'https://aishaquran.com',
    industry: 'education',
    services: ['web'],
    year: '2024',
    title: { en: 'Aisha Quran Academy', ar: 'أكاديمية عائشة للقرآن' },
    tags: {
      en: ['Web platform', 'React', 'Lead generation'],
      ar: ['منصة ويب', 'React', 'جذب العملاء'],
    },
    summary: {
      en: 'A mobile-first learning platform for an online Quran & Arabic academy that teaches students worldwide.',
      ar: 'منصة تعليمية مصمّمة للجوال أولاً لأكاديمية تُعلّم القرآن واللغة العربية عن بُعد لطلاب من حول العالم.',
    },
    client: { en: 'Aisha Quran Academy', ar: 'أكاديمية عائشة للقرآن' },
    role: {
      en: 'Design, development & growth setup',
      ar: 'التصميم والتطوير وتجهيز أدوات النمو',
    },
    overview: {
      en: 'Aisha Quran Academy teaches Quran, Tajweed, and Arabic to non-native speakers through live one-on-one classes with Al-Azhar graduate tutors. We built its complete web platform: the marketing site, a catalogue of 10+ courses for kids and adults, a free-trial registration flow, a blog, and a student login.',
      ar: 'تُعلّم أكاديمية عائشة القرآن والتجويد واللغة العربية لغير الناطقين بها عبر حصص مباشرة فردية مع معلمين من خريجي الأزهر. بنينا منصتها الرقمية بالكامل: الموقع التعريفي، وكتالوج يضم أكثر من 10 دورات للأطفال والكبار، ومسار تسجيل للحصة التجريبية المجانية، ومدونة، وبوابة دخول للطلاب.',
    },
    challenge: {
      en: 'The academy serves families and adult learners across many countries and time zones — most of them on their phones. Visitors had to trust the tutors, understand courses and prices at a glance, and book a free trial in a few taps.',
      ar: 'تخدم الأكاديمية عائلات ومتعلمين كباراً في دول ومناطق زمنية مختلفة، ومعظمهم يتصفح من الجوال. كان على الزائر أن يثق بالمعلمين، ويفهم الدورات والأسعار بسرعة، ويحجز حصة تجريبية ببضع نقرات.',
    },
    solution: {
      en: 'A fast React platform built mobile-first: clear course pages for kids and adults, transparent monthly plans from $64 to $128, a short free-trial form, and one-tap WhatsApp contact pre-filled with the chosen plan. Google Analytics, Google Ads, Meta and TikTok pixels, and Microsoft Clarity are wired in so every campaign can be measured, with SEO metadata on every page.',
      ar: 'منصة React سريعة مصمّمة للجوال أولاً: صفحات دورات واضحة للأطفال والكبار، وباقات شهرية شفافة من 64 إلى 128 دولاراً، ونموذج قصير للحصة التجريبية، وتواصل عبر واتساب بنقرة واحدة برسالة جاهزة تتضمن الباقة المختارة. وربطنا Google Analytics وGoogle Ads وبكسلات Meta وTikTok وMicrosoft Clarity لقياس كل حملة، مع تهيئة SEO لكل صفحة.',
    },
    results: {
      en: [
        '4,000+ live classes delivered through the academy',
        '225+ students enrolled worldwide',
        'Free-trial and WhatsApp leads tracked across Google, Meta, and TikTok',
      ],
      ar: [
        'أكثر من 4,000 حصة مباشرة قدّمتها الأكاديمية',
        'أكثر من 225 طالباً مسجّلاً حول العالم',
        'تتبّع طلبات الحصص التجريبية ورسائل واتساب عبر Google وMeta وTikTok',
      ],
    },
    stack: ['React', 'Vite', 'Google Tag Manager', 'Meta Pixel', 'TikTok Pixel', 'Microsoft Clarity', 'WhatsApp'],
    gallery: {
      desktop: [
        { src: '/images/projects/aisha-academy/desktop-home.webp', alt: { en: 'Home page on desktop', ar: 'الصفحة الرئيسية على سطح المكتب' } },
        { src: '/images/projects/aisha-academy/desktop-courses.webp', alt: { en: 'Course catalogue on desktop', ar: 'كتالوج الدورات على سطح المكتب' } },
        { src: '/images/projects/aisha-academy/desktop-pricing.webp', alt: { en: 'Pricing plans on desktop', ar: 'باقات الأسعار على سطح المكتب' } },
      ],
      tablet: [
        { src: '/images/projects/aisha-academy/tablet-home.webp', alt: { en: 'Home page on tablet', ar: 'الصفحة الرئيسية على الجهاز اللوحي' } },
      ],
      mobile: [
        { src: '/images/projects/aisha-academy/mobile-home.webp', alt: { en: 'Home page on mobile', ar: 'الصفحة الرئيسية على الجوال' } },
        { src: '/images/projects/aisha-academy/mobile-courses.webp', alt: { en: 'Courses on mobile', ar: 'الدورات على الجوال' } },
        { src: '/images/projects/aisha-academy/mobile-pricing.webp', alt: { en: 'Pricing on mobile', ar: 'الأسعار على الجوال' } },
      ],
    },
  },
];
